import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=4fa61f95&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=4fa61f95&lang=scss&scoped=true"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=4fa61f95&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa61f95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fa61f95')) {
      api.createRecord('4fa61f95', component.options)
    } else {
      api.reload('4fa61f95', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=4fa61f95&scoped=true", function () {
      api.rerender('4fa61f95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/Sidebar.vue"
export default component.exports